<i18n>
{
  "fr": {
    "add-business-back-btn": "Retour",
    "add-business-page-title": "Ajouter une entreprise",
    "add-business-page-subtitle": "L'entreprise",
    "add-business-name-label": "Nom de l'entreprise",
    "add-business-name-placeholder": "Entreprise",
    "add-business-jurisdiction-label" : "Juridiction",
    "add-business-jurisdiction-placeholder" : "Assigner une juridiction",
    "add-business-jurisdiction-message" : "Siège social de l'entreprise",
    "error-business-jurisdiction-empty": "La juridiction de l'entreprise est obligatoire",
    "error-business-jurisdiction-other-empty": "Veuillez préciser la juridiction",
    "error-business-jurisdiction-other-too-long": "La juridiction ne peut pas dépasser 100 caractères",
    "add-business-project-template-default-name": "Gabarit de projet / Project template",
    "add-business-project-template-name-label": "Nom du gabarit de projet",
    "add-business-project-template-name-placeholder": "Gabarit de projet / Project template",
    "add-business-type-label": "Il s'agît:",
    "add-business-type-eem-label": "d'une entreprise d'exploration minière",
    "add-business-type-provider-label": "d'un fournisseur",
    "add-business-status-label": "C'est une entreprise:",
    "add-business-status-private-label": "privée",
    "add-business-status-public-label": "publique",
    "add-business-subscription-date-label": "Date d'abonnement",
    "add-business-applicant-subtitle": "Le requérant",
    "add-business-application-text": "Le requérant aura automatiquement le statut d'administrateur",
    "add-applicant-firstname-label": "Prénom",
    "add-applicant-firstname-placeholder": "Prénom",
    "add-applicant-lastname-label": "Nom",
    "add-applicant-lastname-placeholder": "Nom",
    "add-applicant-position-label": "Titre",
    "add-applicant-position-placeholder": "Poste",
    "add-applicant-email-label": "Courriel",
    "add-applicant-email-placeholder": "Courriel",
    "add-applicant-phone-label": "Numéro de téléphone",
    "add-applicant-phone-placeholder": "Ex. 613-555-0152",
    "add-business-btn": "Enregistrer l'entreprise",
    "add-business-btn-subtext": "L'invitation courriel sera envoyée au requérant lors de l'enregistrement",
    "error-business-name-empty": "Le nom de l'entreprise est obligatoire",
    "error-business-project-template-name-empty": "Le nom du gabarit de projet est obligatoire",
    "error-subscription-date-empty": "La date d'abonnement est obligatoire",
    "error-application-firstname-empty": "Le prénom est obligatoire",
    "error-application-lastname-empty": "Le nom de famille est obligatoire",
    "error-application-position-empty": "Le titre est obligatoire",
    "error-application-email-empty": "Le champ courriel ne doit pas être vide",
    "error-application-email-invalid": "Le courriel doit être dans un format valide : courriel@domaine.com",
    "business-list-text": "Liste des entreprises",
    "add-applicant-language-label": "Langue de communication",
    "add-applicant-language-placeholder": "Assigner une langue",
    "error-application-language-empty": "La langue de communication est obligatoire"
  },
  "en": {
    "add-business-back-btn": "Back",
    "add-business-page-title": "Add a company",
    "add-business-page-subtitle": "The company",
    "add-business-name-label": "Company name",
    "add-business-name-placeholder": "Company",
    "add-business-jurisdiction-label" : "Jurisdiction",
    "add-business-jurisdiction-placeholder" : "Set the company jurisdiction",
    "add-business-jurisdiction-message" : "Company Headquarters",
    "error-business-jurisdiction-empty": "Company jurisdiction is mandatory",
    "error-business-jurisdiction-other-empty": "Please specify the jurisdiction",
    "error-business-jurisdiction-other-too-long": "Jurisdiction cannot exceed 100 characters",
    "add-business-project-template-default-name": "Gabarit de projet / Project template",
    "add-business-project-template-name-label": "Project template name",
    "add-business-project-template-name-placeholder": "Gabarit de projet / Project template",
    "add-business-type-label": "This is:",
    "add-business-type-eem-label": "a mineral exploration company",
    "add-business-type-provider-label": "a service provider",
    "add-business-status-label": "This company is:",
    "add-business-status-private-label": "private",
    "add-business-status-public-label": "public",
    "add-business-subscription-date-label": "Subscription date",
    "add-business-applicant-subtitle": "The applicant",
    "add-business-application-text": "The applicant will automatically be defined as an administrator",
    "add-applicant-firstname-label": "First name",
    "add-applicant-firstname-placeholder": "First name",
    "add-applicant-lastname-label": "Last name",
    "add-applicant-lastname-placeholder": "Last name",
    "add-applicant-position-label": "Position",
    "add-applicant-position-placeholder": "Title",
    "add-applicant-email-label": "Email",
    "add-applicant-email-placeholder": "Email",
    "add-applicant-phone-label": "Phone number",
    "add-applicant-phone-placeholder": "Ex. 613-555-0152",
    "add-business-btn": "Register company",
    "add-business-btn-subtext": "An email will be sent to the applicant during registration",
    "error-business-name-empty": "Company name is mandatory",    
    "error-business-project-template-name-empty": "Project template name is mandatory",
    "error-subscription-date-empty": "The subscription date is mandatory",
    "error-application-firstname-empty": "The first name is mandatory",
    "error-application-lastname-empty": "The last name is mandatory",
    "error-application-position-empty": "The position is mandatory",
    "error-application-email-empty": "The email field must not be empty",
    "error-application-email-invalid": "The email address must be in a valid format: email@domain.com",
    "business-list-text": "List of Companies",
    "add-applicant-language-label": "Language of communication",
    "add-applicant-language-placeholder": "Set a language",
    "error-application-language-empty": "The language of communication is mandatory"
  }
}
</i18n>

<template>
  <div class="card">
    <ui-box class="has-background-primary">
      <router-link :to="{ name: $consts.urls.URL_BUSINESS_LIST }" class="has-text-white">
        <span class="icon">
          <i class="fas fa-arrow-left"></i>
        </span>
        <span class="has-text-underline">{{ $t('add-business-back-btn') }}</span>
      </router-link>
      <h1 class="title is-2 has-text-weight-bold has-text-white mt-12px">{{ $t('add-business-page-title') }}</h1>
    </ui-box>
    <ui-box>
      <s-form ref="form" @submit="createBusiness">
        <h2 class="title is-4 mb-16px has-text-weight-bold">{{ $t('add-business-page-subtitle') }}</h2>
        <s-field
          class="has-max-width-480"
          :label="$t('add-business-name-label')"
          :value="business.name"
          :rules="rules.businessNameRules"
          validate-on-input
        >
          <b-input v-model="business.name" :placeholder="$t('add-business-name-placeholder')" />
        </s-field>
        <!-- Juridiction de l'entreprise -->
        <s-field
          :label="$t('add-business-jurisdiction-label')"
          :value="business.jurisdictionCode"
          :rules="rules.businessJurisdictionRules"
          :message="$t('add-business-jurisdiction-message')"
          class="has-max-width-480"
        >
          <jurisdiction-select
            v-model="business.jurisdictionCode"
            :other-value.sync="business.jurisdictionOther"
            :placeholder="$t('add-business-jurisdiction-placeholder')"
          />
        </s-field>

        <s-field
          class="has-max-width-480"
          :label="$t('add-business-project-template-name-label')"
          :value="business.projectTemplateName"
          :rules="rules.projectTemplateNameRules"
          validate-on-input
        >
          <b-input v-model="business.projectTemplateName" :placeholder="$t('add-business-project-template-name-placeholder')" />
        </s-field>
        <s-field class="has-max-width-480" :label="$t('add-business-type-label')">
          <div>
            <div class="mb-4px">
              <b-radio v-model="business.category" :native-value="$consts.enums.BUSINESS_CATEGORY_EEM">
                {{ $t('add-business-type-eem-label') }}
              </b-radio>
            </div>
            <div>
              <b-radio v-model="business.category" :native-value="$consts.enums.BUSINESS_CATEGORY_PROVIDER">
                {{ $t('add-business-type-provider-label') }}
              </b-radio>
            </div>
          </div>
        </s-field>
        <s-field class="has-max-width-480" :label="$t('add-business-status-label')">
          <div>
            <div class="mb-4px">
              <b-radio v-model="business.status" :native-value="$consts.enums.BUSINESS_STATUS_PRIVATE">
                {{ $t('add-business-status-private-label') }}
              </b-radio>
            </div>
            <div>
              <b-radio v-model="business.status" :native-value="$consts.enums.BUSINESS_STATUS_PUBLIC">
                {{ $t('add-business-status-public-label') }}
              </b-radio>
            </div>
          </div>
        </s-field>

        <s-field
          class="has-max-width-480"
          :rules="rules.subscriptionDateRules"
          :label="$t('add-business-subscription-date-label')"
          :value="business.subscriptionDate"
        >
          <s-locale-date
            icon="calendar-day"
            :placeholder="$t('add-business-subscription-date-label')"
            v-model="business.subscriptionDate"
          ></s-locale-date>
        </s-field>

        <div
          :class="{
            'mt-24px': $media.mobile,
            'mt-32px': $media.tablet,
            'mt-48px': $media.fullhd
          }"
        >
          <h2 class="title is-4 mb-4px has-text-weight-bold">{{ $t('add-business-applicant-subtitle') }}</h2>
          <p class="mb-16px has-max-width-768">{{ $t('add-business-application-text') }}</p>
          <div class="mb-4px">
            <s-field
              class="has-max-width-480"
              :label="$t('add-applicant-firstname-label')"
              :value="applicant.firstName"
              :rules="rules.applicantFirstNameRules"
              validate-on-input
            >
              <b-input v-model="applicant.firstName" :placeholder="$t('add-applicant-firstname-placeholder')" />
            </s-field>
            <s-field
              class="has-max-width-480"
              :label="$t('add-applicant-lastname-label')"
              :value="applicant.lastName"
              :rules="rules.applicantLastNameRules"
              validate-on-input
            >
              <b-input v-model="applicant.lastName" :placeholder="$t('add-applicant-lastname-placeholder')" />
            </s-field>
            <s-field
              class="has-max-width-480"
              :label="$t('add-applicant-position-label')"
              :value="applicant.position"
              :rules="rules.applicantPositionRules"
              validate-on-input
            >
              <b-input v-model="applicant.position" :placeholder="$t('add-applicant-position-placeholder')" />
            </s-field>
            <s-field
              class="has-max-width-480"
              :label="$t('add-applicant-email-label')"
              :value="applicant.email"
              :rules="rules.applicantEmailRules"
              validate-on-input
            >
              <b-input v-model="applicant.email" :placeholder="$t('add-applicant-email-placeholder')" />
            </s-field>
            <s-field class="has-max-width-320" :label="$t('add-applicant-phone-label')" optional>
              <b-input v-model="applicant.phoneNumber" :placeholder="$t('add-applicant-phone-placeholder')" />
            </s-field>
            <!--Langue de communication-->
            <s-field
              :label="$t('add-applicant-language-label')"
              :value="applicant.language"
              :rules="rules.applicantLanguageRules"
              class="has-max-width-480"
            >
              <b-select expanded :placeholder="$t('add-applicant-language-placeholder')" v-model="applicant.language">
                <option v-for="i in applicantLanguages" :key="i.value" :value="i.value">{{ i.text }}</option>
              </b-select>
            </s-field>
          </div>
        </div>
        <div
          class="content"
          :class="{
            'mt-24px': $media.mobile,
            'mt-32px': $media.tablet,
            'mt-48px': $media.widescreen
          }"
        >
          <p>
            <b-button type="is-link" native-type="submit">{{ $t('add-business-btn') }}</b-button>
          </p>
          <p class="has-max-width-768">{{ $t('add-business-btn-subtext') }}</p>
        </div>
      </s-form>
    </ui-box>
  </div>
</template>

<script>
import Breadcrumbs from '@/mixins/breadcrumbs'
import SForm from '@/components/form/form'
import SField from '@/components/form/field'
import SLocaleDate from '@/components/form/locale-date'
import JurisdictionSelect from '@/components/form/jurisdiction-select'
import UiBox from '@/components/ui/box'

import { BUSINESS_CATEGORY_PROVIDER, BUSINESS_STATUS_PUBLIC, USER_LANGUAGE_FRENCH, USER_LANGUAGE_ENGLISH } from '@/consts/enums'
import { URL_BUSINESS_LIST } from '@/consts/urls'
import JurisdictionService from '@/services/jurisdiction'
import FormHelper from '@/helpers/form'
import EnumHelper from '@/helpers/enums'
import i18n from '@/helpers/i18n'

export default {
  mixins: [Breadcrumbs],
  components: {
    SForm,
    SField,
    SLocaleDate,
    JurisdictionSelect,
    UiBox
  },
  data() {
    return {
      rules: {
        businessNameRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-business-name-empty')],
        businessJurisdictionRules: [
          (value) => !FormHelper.stringEmpty(value) || this.$t('error-business-jurisdiction-empty'),
          () =>
            JurisdictionService.validateJurisdictionOther(
              this.business.jurisdictionCode,
              this.business.jurisdictionOther,
              this.$t('error-business-jurisdiction-other-empty'),
              this.$t('error-business-jurisdiction-other-too-long')
            )
        ],
        projectTemplateNameRules: [
          (value) => !FormHelper.stringEmpty(value) || this.$t('error-business-project-template-name-empty')
        ],
        applicantFirstNameRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-application-firstname-empty')],
        applicantLastNameRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-application-lastname-empty')],
        applicantPositionRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-application-position-empty')],
        applicantEmailRules: [
          (value) => !FormHelper.stringEmpty(value) || this.$t('error-application-email-empty'),
          (value) => FormHelper.isEmail(value) || this.$t('error-application-email-invalid')
        ],
        applicantLanguageRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-application-language-empty')],
        subscriptionDateRules: [(value) => !FormHelper.stringEmpty(value) || this.$t('error-subscription-date-empty')]
      },
      business: {
        name: '',
        jurisdictionCode: JurisdictionService.defaultJurisdictionCode,
        jurisdictionOther: null,
        projectTemplateName: this.$t('add-business-project-template-default-name'),
        category: BUSINESS_CATEGORY_PROVIDER,
        status: BUSINESS_STATUS_PUBLIC,
        subscriptionDate: new Date().toISOString()
      },
      applicant: {
        firstName: '',
        lastName: '',
        position: '',
        email: '',
        phoneNumber: '',
        language: i18n.userLanguage()
      }
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          url: { name: URL_BUSINESS_LIST },
          label: this.$t('business-list-text')
        },
        {
          label: this.$t('add-business-page-title')
        }
      ]
    },
    applicantLanguages() {
      const languages = [USER_LANGUAGE_FRENCH, USER_LANGUAGE_ENGLISH]

      return languages.map((x) => {
        return {
          value: x,
          text: EnumHelper.formatUserLanguage(x)
        }
      })
    }
  },
  methods: {
    createBusiness: async function () {
      if (this.$refs.form.validate()) {
        const result = await this.$apollo.mutate({
          mutation: this.$options.mutation.CreateBusiness,
          variables: {
            input: {
              ...this.business,
              jurisdictionOther: JurisdictionService.normalizeJurisdictionOther(
                this.business.jurisdictionCode,
                this.business.jurisdictionOther
              )
            }
          }
        })

        const business = result.data.createBusiness.business

        if (this.applicant.phoneNumber === '') this.applicant.phoneNumber = null

        await this.$apollo.mutate({
          mutation: this.$options.mutation.UpdateApplicantBusiness,
          variables: {
            input: {
              businessId: business.id,
              ...this.applicant
            }
          }
        })

        this.$router.push({ name: URL_BUSINESS_LIST })
      }
    }
  }
}
</script>

<graphql>
mutation CreateBusiness($input: CreateBusinessInput!) {
  createBusiness(input: $input) {
    business {
      id
      category
      name
      jurisdictionCode
      jurisdictionOther
      status
      subscriptionDate
    }
  }
}

mutation UpdateApplicantBusiness($input: UpdateApplicantBusinessInput!) {
  updateApplicantBusiness(input: $input) {
    business {
      id
      applicant {
        id
        email
        profile {
          id
          firstName
          lastName
          language
        }
      }
    }
  }
}
</graphql>
